(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["snoozair-language-menu"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sa-language-menu'))customElements.define('sa-language-menu',class extends HTMLElement{
connectedCallback(){this.controller?.abort();this.controller=new AbortController();const options={signal:this.controller.signal};const details=this.querySelector('details');const summary=this.querySelector('summary');this.addEventListener('keydown',event=>{if(event.key==='Escape'&&details.open){event.preventDefault();details.open=false;summary.focus({preventScroll:true});}},options);document.addEventListener('pointerdown',event=>{if(details.open&&!this.contains(event.target))details.open=false;},options);this.addEventListener('focusout',event=>{if(event.relatedTarget&&!this.contains(event.relatedTarget))details.open=false;},options);}
disconnectedCallback(){this.controller?.abort();}
});
  } catch(e) { console.error(e); }
})();

})();
